export class ViaAccess {
    name: string;
    id: number;
    code: string;
}
